import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Typography } from '@mui/material';
import LinearStrip from './LinearStrip';

// const initialBackgroundImage = 'https://s3-alpha-sig.figma.com/img/61ff/361b/11e4dd09e9abf67bf4cbaef596d3cd0a?Expires=1708905600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=KwblSwS~WD97lvxW3mhlOqAj0sh5bAXrCu-nb01W8XmHyBHQ5I8aJZBVpNM7eTrzrVz92AQy~9FROKxdFs~v7JfcVFX16lSyW3fEgGsXwS8bKwxcJytLJd3IYASfOffDj~Wf1vK9wGjI588GLXYhgRugQ0XOwJi34qgZXPqnztRHT~WqvOyVrUBimYJ9IdGNpDM9Bo9nF3RKiIWBcBWD1LJTjjQUubdDjc5ZUnrapxGAAJrOfZidYeRD48ZRTFbsemfS6o2uvTeNwQ3BnVbCJLA~RCwOw6OhdBtt7PvbMfZ1AsVs9yP6MX5f85b~j5zc7LmZvO54GLQh~rvvGyic6w__';

const initialBackgroundImage = 'https://imgur.com/lrTWHNw';


const secondaryBackgroundImage = initialBackgroundImage // 'https://i.imgur.com/0vt1uj3.jpeg'; // making these changes till achar sanhita

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    minHeight: '100vh',
    marginTop: theme.spacing(0.5)
  },
  additionalCard: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    height: '75px',
    background: 'rgba(30, 30, 30, 0.16)', // Adjust colors and transparency
    color: 'white',
  },
  strip: {
    position: 'absolute',
    top: theme.spacing(75), // Adjust the top position as needed
    width: '100%',
    textAlign: 'center',
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1,
    backgroundSize: 'cover',
    backgroundColor: 'rgba(255, 255, 255, 0.7)', // Adjust the transparency as needed
    transition: 'background-image 2s ease-in-out',
  },
}));

const Development = () => {
  const classes = useStyles();
  const [backgroundImage, setBackgroundImage] = useState(initialBackgroundImage);

  useEffect(() => {
    const interval = setInterval(() => {
      setBackgroundImage((prevImage) =>
        prevImage === initialBackgroundImage ? secondaryBackgroundImage : initialBackgroundImage
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classes.root}>
      <Card className={classes.additionalCard}>
        <CardContent>
          <Typography variant="body1">Development is about transforming <br /> the lives of people</Typography>
        </CardContent>
      </Card>
      {/* hiding it till achar sanhita
      <div className={classes.strip}>
        <LinearStrip />
      </div>
      */}
      <div className={classes.backgroundImage} style={{ backgroundImage: `url(${backgroundImage})` }} />
    </div>
  );
};

export default Development;
